@if (showModal) {
  <app-close-modal (closeModal)="closeModal($event)"></app-close-modal>
}
